const ShopifyStoreLink = `${process.env.REACT_APP_SHOPIFY_STORE_LINK}/api/2022-04/graphql.json`;
const ShopifyStoreLink2210 = `${process.env.REACT_APP_SHOPIFY_STORE_LINK}/api/2022-10/graphql.json`;
const ShopifyAdminLink = `${process.env.REACT_APP_SHOPIFY_STORE_LINK}/admin/api/2022-04/graphql.json`;
const ShopifyStoreFrontAccessToken = process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN;
const replaceurlbystore = process.env.REACT_APP_SHOPIFY_STORE_LINK;
const replaceurlbycheckout = process.env.REACT_APP_SHOPIFY_STORE_CHECKOT_LINK;
const GET_DATA_URL = process.env.REACT_APP_DATA_API_URL;
const AdminAPIUrl = process.env.REACT_APP_ADMIN_API_URL;
const MediaAPIUrl = process.env.REACT_APP_MEDIA_API_URL;
const MailchimpAPI = "https://gmail.us9.list-manage.com/subscribe/post-json?u=c786617ff79d103f8f5c6805a&amp;id=14679cbdca";
const StateCodeList = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"]
const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY;
const ALGOLIA_APPLICATION_ID = process.env.REACT_APP_ALGOLIA_APPLICATION_ID;
const SIMPLY_PAID_URL = "https://simplypaid.com.au/Ezypayhub/directlaunch?tkn="
const user_title = [
    'Accounts',
    'Administration',
    'Civil Engineer',
    'Construction Manager',
    'Contract Administrator',
    'Director',
    'Draftsman',
    'Electrician',
    'Engineer',
    'Estimator',
    'Finance Manager',
    'Foreman',
    'General Manager',
    'Hydraulic Engineer',
    'Leading Hand',
    'Mechanical Engineer',
    'Office Manager',
    'Operations Manager',
    'Plumber',
    'Production Manager',
    'Project Administrator',
    'Project Manager',
    'Purchasing',
    'Reception',
    'Site Manager',
    'Storeman',
    'Structural Engineer',
    'Supervisor',
    'Warehouse Manager',
    'Workshop Manager']

export {
    ShopifyStoreLink,
    ShopifyStoreLink2210,
    ShopifyAdminLink,
    ShopifyStoreFrontAccessToken,
    replaceurlbystore,
    GET_DATA_URL,
    AdminAPIUrl,
    MediaAPIUrl,
    MailchimpAPI,
    StateCodeList,
    ALGOLIA_API_KEY,
    ALGOLIA_APPLICATION_ID,
    SIMPLY_PAID_URL,
    user_title,
    replaceurlbycheckout,
    
};